import { useNavigate } from "react-router-dom";
import { logAnalyticsEvent } from "../../engagement/Amplitude";
import { useAuth } from "../../authentication/AuthContext";
import SignUpModal from "../../authentication/SignUpModal";
import LogInModal from "../../authentication/LogInModal";
import { useState } from "react";
import { supabase } from "../../../supabaseClient";

export default function StartAChat() {
  const navigate = useNavigate();
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const { user } = useAuth();
  const handleStartAChat = () => {
    logAnalyticsEvent("Press Start a Chat");

    if (user == null) {
      logAnalyticsEvent("Start a Chat - Not Logged In");
      setIsSignUpOpen(true);
    } else {
      navigate("/chat");
    }
  };

  return (
    <div>
      <div className="flex justify-end">
        <button
          className={`btn btn-primary text-primary-content btn-sm md:btn-md`}
          onClick={handleStartAChat}
        >
          <div className="hidden sm:block">Start a Chat</div>
          <div className="sm:hidden block">+ Chat</div>
        </button>
      </div>
      <SignUpModal
        isOpen={isSignUpOpen}
        onClose={() => setIsSignUpOpen(false)}
      />
      <LogInModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
      />
    </div>
  );
}
